module.exports = __webpack_public_path__ + "img/icon-save.a84fa017.svg";